import React from 'react';

import useAppContext from 'flow/hooks/useAppContext';

const CalendarExternallyManagedInfo = () => {
    const { i18next } = useAppContext();

    return (
        <p className="mb-4 rounded-sm bg-gray-100 px-4 py-2 text-xs leading-5 text-black">
            {i18next.t('calendar.other.external.managed_info')}
        </p>
    );
};

export default CalendarExternallyManagedInfo;
